module.exports = __webpack_public_path__ + "img/charity.5a5abe4a.jpg";